export default [
  { id: 'ServicePatternDetail', label: 'Service Pattern Maintenance', parent: '' },
];
